// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as SplatRouteImport } from './routes/$'
import { Route as AboutRouteImport } from './routes/about'
import { Route as AelaRouteImport } from './routes/aela'
import { Route as BlogRouteImport } from './routes/blog'
import { Route as CaseStudyRouteImport } from './routes/case-study'
import { Route as ContactRouteImport } from './routes/contact'
import { Route as DioroRouteImport } from './routes/dioro'
import { Route as Dioro_dpaRouteImport } from './routes/dioro_dpa'
import { Route as ExclusivePartnerDealRouteImport } from './routes/exclusive-partner-deal'
import { Route as SalesforceProcurementRouteImport } from './routes/salesforce-procurement'
import { Route as SelaRouteImport } from './routes/sela'
import { Route as ServicesRouteImport } from './routes/services'
import { Route as Software_and_services_agreementRouteImport } from './routes/software_and_services_agreement'
import { Route as BlogIndexRouteImport } from './routes/blog.index'
import { Route as BlogSlugRouteImport } from './routes/blog.$slug'
import { Route as BlogAuthorSlugRouteImport } from './routes/blog.author.$slug'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const SplatRoute = SplatRouteImport.update({
            id: '/$',path: '/$',getParentRoute: () => rootRouteImport
          })
const AboutRoute = AboutRouteImport.update({
            id: '/about',path: '/about',getParentRoute: () => rootRouteImport
          })
const AelaRoute = AelaRouteImport.update({
            id: '/aela',path: '/aela',getParentRoute: () => rootRouteImport
          })
const BlogRoute = BlogRouteImport.update({
            id: '/blog',path: '/blog',getParentRoute: () => rootRouteImport
          })
const CaseStudyRoute = CaseStudyRouteImport.update({
            id: '/case-study',path: '/case-study',getParentRoute: () => rootRouteImport
          })
const ContactRoute = ContactRouteImport.update({
            id: '/contact',path: '/contact',getParentRoute: () => rootRouteImport
          })
const DioroRoute = DioroRouteImport.update({
            id: '/dioro',path: '/dioro',getParentRoute: () => rootRouteImport
          })
const Dioro_dpaRoute = Dioro_dpaRouteImport.update({
            id: '/dioro_dpa',path: '/dioro_dpa',getParentRoute: () => rootRouteImport
          })
const ExclusivePartnerDealRoute = ExclusivePartnerDealRouteImport.update({
            id: '/exclusive-partner-deal',path: '/exclusive-partner-deal',getParentRoute: () => rootRouteImport
          })
const SalesforceProcurementRoute = SalesforceProcurementRouteImport.update({
            id: '/salesforce-procurement',path: '/salesforce-procurement',getParentRoute: () => rootRouteImport
          })
const SelaRoute = SelaRouteImport.update({
            id: '/sela',path: '/sela',getParentRoute: () => rootRouteImport
          })
const ServicesRoute = ServicesRouteImport.update({
            id: '/services',path: '/services',getParentRoute: () => rootRouteImport
          })
const Software_and_services_agreementRoute = Software_and_services_agreementRouteImport.update({
            id: '/software_and_services_agreement',path: '/software_and_services_agreement',getParentRoute: () => rootRouteImport
          })
const BlogIndexRoute = BlogIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => BlogRoute
          })
const BlogSlugRoute = BlogSlugRouteImport.update({
            id: '/$slug',path: '/$slug',getParentRoute: () => BlogRoute
          })
const BlogAuthorSlugRoute = BlogAuthorSlugRouteImport.update({
            id: '/author/$slug',path: '/author/$slug',getParentRoute: () => BlogRoute
          })





const BlogRouteChildren = {
  BlogSlugRoute: BlogSlugRoute,BlogIndexRoute: BlogIndexRoute,BlogAuthorSlugRoute: BlogAuthorSlugRoute
}

const BlogRouteWithChildren = BlogRoute._addFileChildren(BlogRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,SplatRoute: SplatRoute,AboutRoute: AboutRoute,AelaRoute: AelaRoute,BlogRoute: BlogRouteWithChildren,CaseStudyRoute: CaseStudyRoute,ContactRoute: ContactRoute,DioroRoute: DioroRoute,Dioro_dpaRoute: Dioro_dpaRoute,ExclusivePartnerDealRoute: ExclusivePartnerDealRoute,SalesforceProcurementRoute: SalesforceProcurementRoute,SelaRoute: SelaRoute,ServicesRoute: ServicesRoute,Software_and_services_agreementRoute: Software_and_services_agreementRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)